import axios from 'axios';
import AuthService from './auth'
import CategoriaService from './categoria';
import UsuarioService from './usuario';
import ColunistaService from './colunista';
import ColunaService from './coluna';
import NoticiaService from './noticia';
import LoginService from './login';
import EventoService from './evento';
import ParceirosService from './parceiros';
import PropagandaService from './propaganda';
import NegocioService from './negocio';
import ContosService from './contos';

const API_ENVS = {
  production: '',
  development: '',
  local: 'https://backendrural.centrion.com.br/api/' //http://192.168.3.12:8989/api/
}
const httpClient = axios.create({
  baseURL: API_ENVS.local
})
export default {
  devServer: {
    proxy: 'https://192.168.3.12:8989/api/'
  },
  auth: AuthService(httpClient),
  categoria: CategoriaService(httpClient),
  usuario: UsuarioService(httpClient),
  colunista: ColunistaService(httpClient),
  coluna: ColunaService(httpClient),
  noticia: NoticiaService(httpClient),
  login: LoginService(httpClient),
  evento: EventoService(httpClient),
  parceiros: ParceirosService(httpClient),
  propaganda: PropagandaService(httpClient),
  negocio: NegocioService(httpClient),
  contos: ContosService(httpClient),
}